import React from 'react';
import { motion } from 'framer-motion';
import { ShoppingBagIcon, HomeIcon, PartyPopperIcon, Building2Icon, ArrowRightIcon } from 'lucide-react';
import { SMS_HREF } from '../lib/contact';
const OFFERINGS = [{
  icon: ShoppingBagIcon,
  title: 'Buy One',
  body: 'Own a custom barrel trash can built to your finish, hardware, and branding. Perfect for patios, kitchens, and shops.'
}, {
  icon: HomeIcon,
  title: 'Rent 1:1',
  body: 'Need one for a season or a stretch? Rent a single barrel by the week or month with easy pickup and return.'
}, {
  icon: PartyPopperIcon,
  title: 'Party Rentals',
  body: 'Weddings, ranch dinners, and backyard bashes. Rent a set of matching barrels to keep the celebration tidy and on-theme.'
}, {
  icon: Building2Icon,
  title: 'Venues & Wholesale',
  body: 'Outfitting a winery, tasting room, or event space? We build in volume with consistent, custom detailing.'
}];
export function Offerings() {
  return <section id="offerings" className="bg-parchment py-16 sm:py-24" data-id="element-118" data-mp="2mdq0081bab2a">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-119" data-mp="2mg2o72xnxhns">
        <div data-id="element-120" data-mp="2hggc4wtkm7gk">
          <span className="font-stamp text-xs uppercase tracking-[0.25em] text-wine" data-id="element-121" data-mp="2hgpvw2o0vidt">
            Ways to Work With Us
          </span>
          <h2 className="mt-3 whitespace-nowrap font-display text-[clamp(0.75rem,3.8vw,2.25rem)] leading-tight text-oak-dark" data-id="element-122" data-mp="2qftd113mpnpo">
            Buy it, rent it, or fill your venue with it.
          </h2>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4" data-id="element-123" data-mp="30eiw2x79he7i">
          {OFFERINGS.map((item, i) => {
          const Icon = item.icon;
          return <motion.div key={item.title} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-60px'
          }} transition={{
            duration: 0.5,
            delay: i * 0.08
          }} className="flex flex-col rounded-sm border-2 border-oak-dark/25 bg-cream p-6 shadow-sm" data-id="element-124" data-mp="3a3sm87ijomsz" data-mpi={i}>
                <span className="flex h-12 w-12 items-center justify-center rounded-full bg-oak-dark text-cream" data-id="element-125" data-mp="2ksejh29gfya2">
                  <Icon className="h-6 w-6" aria-hidden="true" data-id="element-126" data-mp="2pr8z5vc4l6py" />
                </span>
                <h3 className="mt-4 font-display text-xl text-oak-dark" data-id="element-127" data-mp="2ui7jr745cqz0">{item.title}</h3>
                <p className="mt-2 flex-1 font-body text-sm leading-relaxed text-bark/80" data-id="element-128" data-mp="2zhkesf5694co">
                  {item.body}
                </p>
              </motion.div>;
        })}
        </div>

        <div className="mt-10 flex flex-col items-start gap-3 border-t-2 border-oak-dark/20 pt-8 sm:flex-row sm:items-center sm:justify-between" data-id="element-129" data-mp="38iia891jo3jn">
          <p className="font-body text-lg text-bark" data-id="element-130" data-mp="3dg1wnw8ebmmo">
            Every order is custom. Tell us what you have in mind.
          </p>
          <a href={SMS_HREF} className="inline-flex items-center gap-2 font-stamp text-sm uppercase tracking-widest text-wine transition-colors hover:text-oak-dark" data-id="element-131" data-mp="1e6lpeyxlxvxk">
            Text us your idea
            <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-132" data-mp="16sktl0j8ik6u" />
          </a>
        </div>
      </div>
    </section>;
}